export class VerifyEmailFakeDb {
  public static users = [];
}
